import React, { useState, useEffect } from 'react';
import { X, Send, User, Mail, Phone, ShieldCheck, ArrowRight, Clipboard } from 'lucide-react';
import { useUI } from '../context/UIContext';
import './EnquiryPopup.css';

const EnquiryPopup = ({ isOpen, onClose }) => {
    const { popupData } = useUI();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        insuranceType: 'health',
        interestedIn: ''
    });

    useEffect(() => {
        if (popupData) {
            setFormData(prev => ({
                ...prev,
                interestedIn: popupData
            }));
        }
    }, [popupData, isOpen]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        // Simulate high-performance API call
        setTimeout(() => {
            setIsSubmitting(false);
            setIsSuccess(true);
            setTimeout(() => {
                setIsSuccess(false);
                onClose();
            }, 3000);
        }, 1500);
    };

    if (!isOpen) return null;

    return (
        <div className="enquiry-overlay">
            <div className="enquiry-modal animate-pop">
                <button className="enquiry-close" onClick={onClose}><X size={24} /></button>
                
                <div className="enquiry-content">
                    <div className="enquiry-header">
                        <div className="enquiry-logo">
                            <ShieldCheck size={32} />
                        </div>
                        <h2>Get Professional Guidance</h2>
                        <p>Fill in your details and our elite insurance experts will provide a customized quote within 4 working hours.</p>
                    </div>

                    {!isSuccess ? (
                        <form className="enquiry-form" onSubmit={handleSubmit}>
                            <div className="enquiry-group">
                                <label><User size={16} /> Full Name</label>
                                <input 
                                    type="text" 
                                    name="name" 
                                    placeholder="Enter your name" 
                                    required 
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="enquiry-group">
                                <label><Mail size={16} /> Email Address</label>
                                <input 
                                    type="email" 
                                    name="email" 
                                    placeholder="you@email.com" 
                                    required 
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="enquiry-group">
                                <label><Phone size={16} /> Phone Number</label>
                                <input 
                                    type="tel" 
                                    name="phone" 
                                    placeholder="99999xxxxx" 
                                    required 
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="enquiry-group">
                                <label><Clipboard size={16} /> Selected Plan</label>
                                <input 
                                    type="text" 
                                    name="interestedIn" 
                                    placeholder="Which plan are you looking for?" 
                                    value={formData.interestedIn}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="enquiry-group">
                                <label>Plan Category</label>
                                <select 
                                    name="insuranceType"
                                    value={formData.insuranceType}
                                    onChange={handleChange}
                                >
                                    <option value="life">Life Insurance</option>
                                    <option value="health">Health Insurance</option>
                                    <option value="motor">Motor Insurance</option>
                                    <option value="property">Property Insurance</option>
                                    <option value="business">Business Insurance</option>
                                    <option value="travel">Travel Insurance</option>
                                </select>
                            </div>

                            <button type="submit" className="enquiry-btn" disabled={isSubmitting}>
                                {isSubmitting ? 'Processing...' : (
                                    <>
                                        Get Your Quote <ArrowRight size={18} />
                                    </>
                                )}
                            </button>
                            <p className="enquiry-privacy">Your data is secured with 256-bit encryption. No spam, ever.</p>
                        </form>
                    ) : (
                        <div className="enquiry-success animate-fade">
                            <div className="success-icon">✓</div>
                            <h3>Inquiry Received!</h3>
                            <p>Our experts are analyzing your requirements. We'll be in touch with your customized quote shortly.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EnquiryPopup;
